import ApiClient from "../api/apiClient";

const INCOMPLETE_APPLICATIONS = "/certificates/incomplete-applications";
const STATUS_COUNT = "/certificates/incomplete-applications/count";
const APPLICANT_DETAILS_BY_USER = "/certificates/applicant-details-by-user/";


const getincompleteApplications = ({
    page,
    limit,
    type,
    start_date,
    end_date,
    full_name,
    registered_from,
    registered_to,
    board_approval_from,
    board_approval_to,
    email,
    filter_status,
    registration_no,
    technology_field,
    identity_number,
    payment_from,
    payment_to,
    search,
    status,
    assessment_from,
    assessment_to,
}) => {
    const baseUrl = `${INCOMPLETE_APPLICATIONS}?`;

    let queryParams = "";

    queryParams += `page=${page}&limit=${limit}&type=${type}`;

    if (full_name) queryParams += `&full_name=${full_name}`;
    if (email && email !== undefined && email !== "" && email !== null) queryParams += `&email=${email}`;
    if (registration_no) queryParams += `&registration_no=${registration_no}`;
    if (filter_status) queryParams += `&filter_status=${filter_status}`;
    if (registered_from) queryParams += `&registered_from=${registered_from}`;
    if (registered_to) queryParams += `&registered_to=${registered_to}`;
    if (board_approval_from) queryParams += `&board_approval_from=${board_approval_from}`;
    if (board_approval_to) queryParams += `&board_approval_to=${board_approval_to}`;
    if (technology_field) queryParams += `&technology_field=${technology_field}`;
    if (identity_number) queryParams += `&identity_number=${identity_number}`;
    if (payment_from) queryParams += `&payment_from=${payment_from}`;
    if (payment_to) queryParams += `&payment_to=${payment_to}`;
    if (assessment_from) queryParams += `&assessment_from=${assessment_from}`;
    if (assessment_to) queryParams += `&assessment_to=${assessment_to}`;
    if (search) queryParams += `&search=${search}`;
    if (start_date) queryParams += `&start_date=${start_date}`;
    if (end_date) queryParams += `&end_date=${end_date}`;

    const url = baseUrl + queryParams;

    return ApiClient.get(url);
};

const getIncompleteApplicationCount = ({
    start_date,
    end_date,
    full_name,
    registered_from,
    registered_to,
    board_approval_from,
    board_approval_to,
    email,
    filter_status,
    registration_no,
    technology_field,
    identity_number,
    payment_from,
    payment_to,
    search,
    status,
    assessment_from,
    assessment_to }) => {
    const baseUrl = `${STATUS_COUNT}?`;
    let queryParams = "";


    if (full_name) queryParams += `&full_name=${full_name}`;
    if (email) queryParams += `&email=${email}`;
    if (filter_status) queryParams += `&filter_status=${filter_status}`;
    if (registered_from) queryParams += `&registered_from=${registered_from}`;
    if (registered_to) queryParams += `&registered_to=${registered_to}`;
    if (board_approval_from) queryParams += `&board_approval_from=${board_approval_from}`;
    if (board_approval_to) queryParams += `&board_approval_to=${board_approval_to}`;
    if (registration_no) queryParams += `&registration_no=${registration_no}`;
    if (technology_field) queryParams += `&technology_field=${technology_field}`;
    if (identity_number) queryParams += `&identity_number=${identity_number}`;
    if (payment_from) queryParams += `&payment_from=${payment_from}`;
    if (payment_to) queryParams += `&payment_to=${payment_to}`;
    if (assessment_from) queryParams += `&assessment_from=${assessment_from}`;
    if (assessment_to) queryParams += `&assessment_to=${assessment_to}`;
    if (search) queryParams += `&search=${search}`;
    if (start_date) queryParams += `&start_date=${start_date}`;
    if (end_date) queryParams += `&end_date=${end_date}`;

    const url = baseUrl + queryParams;

    return ApiClient.get(url);
};

const getIncompleteApplicationssProfileInformation = ({ id }) => {
    const url = APPLICANT_DETAILS_BY_USER + id;
    return ApiClient.get(url);
};

export const incompleteApplicationsService = {
    getincompleteApplications,
    getIncompleteApplicationCount,
    getIncompleteApplicationssProfileInformation
};